import React from 'react';
import { AlertTriangle, X, Trash2, Shield } from 'lucide-react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText, type = 'danger' }) => {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'danger':
        return {
          iconBg: 'bg-red-500/20',
          iconColor: 'text-red-400',
          confirmBg: 'bg-red-600 hover:bg-red-700',
          borderColor: 'border-red-500/30'
        };
      case 'warning':
        return {
          iconBg: 'bg-yellow-500/20',
          iconColor: 'text-yellow-400',
          confirmBg: 'bg-yellow-600 hover:bg-yellow-700',
          borderColor: 'border-yellow-500/30'
        };
      default:
        return {
          iconBg: 'bg-blue-500/20',
          iconColor: 'text-blue-400',
          confirmBg: 'bg-blue-600 hover:bg-blue-700',
          borderColor: 'border-blue-500/30'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 backdrop-blur-md bg-black/70 z-[11500] animate-in fade-in duration-200"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-md z-[12000] animate-in zoom-in-95 duration-200" dir="rtl">
        <div className={`bg-slate-800 rounded-2xl border ${styles.borderColor} shadow-2xl overflow-hidden`}>
          
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-slate-700">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${styles.iconBg}`}>
                {type === 'danger' ? (
                  <AlertTriangle className={`w-5 h-5 ${styles.iconColor}`} />
                ) : type === 'warning' ? (
                  <AlertTriangle className={`w-5 h-5 ${styles.iconColor}`} />
                ) : (
                  <Shield className={`w-5 h-5 ${styles.iconColor}`} />
                )}
              </div>
              <h3 className="text-xl font-bold text-white">
                {title || 'تأكيد العملية'}
              </h3>
            </div>
            
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white p-2 hover:bg-slate-700 rounded-lg transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-gray-300 text-base leading-relaxed mb-6">
              {message || 'هل أنت متأكد من أنك تريد حذف هذا الوكيل؟'}
            </p>

            <div className="bg-slate-700/30 p-4 rounded-xl mb-6">
              <div className="flex items-start gap-2">
                <AlertTriangle className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-yellow-400 text-sm font-medium">تحذير:</p>
                  <p className="text-gray-300 text-xs mt-1">
                    هذا الإجراء لا يمكن التراجع عنه. تأكد من صحة قرارك قبل المتابعة.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex gap-3 p-6 border-t border-slate-700">
            <button 
              className="flex-1 px-4 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-xl transition-colors font-medium"
              onClick={onClose}
            >
              {cancelText || 'إلغاء'}
            </button>
            <button 
              className={`flex-1 px-4 py-3 ${styles.confirmBg} text-white rounded-xl transition-colors font-bold flex items-center justify-center gap-2`}
              onClick={onConfirm}
            >
              {type === 'danger' && <Trash2 className="w-4 h-4" />}
              {confirmText || 'نعم، احذف'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;